document.addEventListener('DOMContentLoaded', function () {
  const collections = document.querySelectorAll('.build-step-collection');
  const addToCartBtns = document.querySelectorAll('.step_add_to_cart, .mobile_step_add_to_cart');
  const steps = document.querySelectorAll('.build-step');
  const buildProducts = document.querySelector('.build-products');
  // const buildComplete = document.querySelector('.build-complete');

  let selectedVariants = [];
  const maxItems = 5;

  // 🔹 Helper: Get variant ID safely
  function getVariantId(el) {
    return parseInt(
      el.dataset.variant_id || el.dataset.variantId || el.getAttribute('data-variant-id')
    );
  }

  // 🔹 Helper: Get product ID safely
  function getProductId(el) {
    return parseInt(
      el.dataset.product_id || el.dataset.productId || el.getAttribute('data-product-id')
    );
  }

  // 🔹 Update product button text and style
  function updateButtons(productId) {
    const productQty = selectedVariants
      .filter(v => v.productId === productId)
      .reduce((sum, v) => sum + v.quantity, 0);

    document.querySelectorAll(
      `[data-product_id="${productId}"], [data-product-id="${productId}"]`
    ).forEach(btn => {
      if (productQty > 0) {
        btn.classList.add('selected');
        btn.textContent = `Added (${productQty})`;
      } else {
        btn.classList.remove('selected');
        btn.textContent = 'Add';
      }
    });
  }

  // 🔹 Update progress steps
  function updateProgress() {
    const expandedVariants = selectedVariants.flatMap(v => Array(v.quantity).fill(v));
    const total = expandedVariants.length;

    steps.forEach((step, index) => {
      const stepNumber = step.querySelector('.step-number');
      const stepImage = step.querySelector(`#step-image-${index + 1}`);
      step.classList.remove('active');
      if (stepNumber) stepNumber.style.display = '';
      if (stepImage) stepImage.innerHTML = '';

      if (index < total) {
        const variant = expandedVariants[index];
        step.classList.add('active');
        if (stepNumber) stepNumber.style.display = 'none';

        const img = document.createElement('img');
        img.src = variant.img;
        img.classList.add('progress-image');

        const removeBtn = document.createElement('span');
        removeBtn.classList.add('remove-step-image');
        removeBtn.textContent = '✖';
        removeBtn.dataset.variantId = variant.id;

        removeBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          decrementVariant(parseInt(this.dataset.variantId));
        });

        stepImage.appendChild(img);
        stepImage.appendChild(removeBtn);
      }
    });

    // 🔹 Toggle Add-to-Cart button visibility
    if (total >= maxItems) {
      addToCartBtns.forEach(btn => btn.classList.add('active'));
      buildProducts.querySelector('.bundle-product-grid').classList.add('disable_collection');
      addToCartBtns[0]?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
      addToCartBtns.forEach(btn => btn.classList.remove('active'));
      buildProducts.querySelector('.bundle-product-grid').classList.remove('disable_collection');
      buildProducts.style.display = '';
    }
  }

  // 🔹 Remove / Decrement variant
  function decrementVariant(variantId) {
    const variant = selectedVariants.find(v => v.id === variantId);
    if (!variant) return;

    variant.quantity -= 1;
    if (variant.quantity <= 0) {
      const productId = variant.productId;
      selectedVariants = selectedVariants.filter(v => v.id !== variantId);
      updateButtons(productId);
    } else {
      updateButtons(variant.productId);
    }

    updateProgress();
  }

  // 🔹 Handle "Add" button clicks inside each collection
  collections.forEach(collection => {
    const addButtons = collection.querySelectorAll('.add-box');

    addButtons.forEach(button => {
      button.addEventListener('click', function () {
        const productItem = this.closest('.byob-product-item');
        const variantId = getVariantId(this);
        const productId = getProductId(this) || getProductId(productItem);
        if (!variantId) return;

        let imgTag =
          productItem?.querySelector('.product-media-item[style*="display: block"] img') ||
          productItem?.querySelector('.product-media-wrapper img');
        const imgSrc = imgTag?.src;

        const existingVariant = selectedVariants.find(v => v.id === variantId);
        const total = selectedVariants.reduce((sum, v) => sum + v.quantity, 0);

        if (total >= maxItems && !existingVariant) {
          alert(`You can only select up to ${maxItems} products.`);
          return;
        }

        if (existingVariant) {
          existingVariant.quantity += 1;
        } else {
          selectedVariants.push({
            id: variantId,
            productId,
            quantity: 1,
            img: imgSrc,
            properties: { _build_box: 'buildBox' },
          });
        }

        updateButtons(productId);
        updateProgress();
      });
    });
  });

  // 🔹 Handle Add to Cart (for both desktop and mobile)
  addToCartBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const total = selectedVariants.reduce((sum, v) => sum + v.quantity, 0);

      if (total < maxItems) {
        alert(`Please select ${maxItems} products before adding to cart.`);
        return;
      }
      // Add loader class & disable button
        btn.classList.add('loading');
        btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: selectedVariants }),
      })
        .then(r => r.json())
        .then(data => {
          console.log('Cart updated:', data);
          window.refreshCart?.(); // If custom cart drawer refresh is available
        })
         .catch(err => {
        console.error('Error:', err);
        alert('Something went wrong while adding to cart.');
      })
      .finally(() => {
        btn.classList.remove('loading');
        btn.disabled = false;
      });
    });
  });
});
